var badgeText1 = "<span class=\"shipscout-hide-if-active\">FREE SHIPPING OVER $99 USD</span><span class=\"shipscout-show-if-variant-A\" style=\"display: none\">FREE SHIPPING OVER $99</span><span class=\"shipscout-show-if-variant-B\" style=\"display: none\">FREE SHIPPING FOR ALL ORDERS</span>";
var badgeText2 = "LIFETIME WARRANTY GUARANTEE";

var shippingPopup = `<div class="simple-popup simple-shipping-popup">
    <div class="popup-content">
        <div class="popup-title">Shipping<span class="simple-close">×</span></div>
        <div class="popup-p">
            <div class="popup-contentt">
                <div class="Rte">
                    <h4><tab-2_text><b><span style="color:black">FREE Shipping Worldwide over $99 USD</h4>
                    
                    <p>After your your payment is verified it will take 2-3 business days to process and ship your order
                        out! (This does not include weekends &amp; holidays)</p>
                    <p><tab-2_text>Shipping times &amp; rates (Excluding processing time)</tab-2_text></p>
                    <p><strong><span style="line-height:1.4">United States:</span></strong></p>
                    <ul class="shipscout-hide-if-active">
                        <li><strong>FREE Shipping over $99 USD</strong></span></li>
                        <li><span>Standard Shipping (3-8 Business days) -&nbsp;<strong>$4.95</strong></span></li>
                        <li><span>Not Available: Expedited Shipping (1-3 Business days) -<strong>$15</strong></span>
                        </li>
                    </ul>
                    <ul class="shipscout-show-if-variant-A shipscout-show-if-default-rate" style="display: none">
                        <li><strong>FREE Shipping over $99 USD</strong></span></li>
                        <li><span>Standard Shipping (3-8 Business days) -&nbsp;<strong>$4.95</strong></span></li>
                        <li><span>Not Available: Expedited Shipping (1-3 Business days) -<strong>$15</strong></span>
                        </li>
                    </ul>
                    <ul class="shipscout-show-if-variant-B" style="display: none">
                        <li><strong>FREE Shipping on all orders</strong></span></li>
                        <li><span>Not Available: Expedited Shipping (1-3 Business days) -<strong>$15</strong></span>
                        </li>
                    </ul>
                    <p><strong><span style="line-height:1.4">Canada:</span></strong></p>
                    <ul>
                        <li><strong>FREE Shipping over $99 USD</strong></span></li>
                        <li>Canada Standard Shipping (7-12 Business days) -<b>$5.95</b></li>
                        <li>Not Available: Express Shipping (3-6 Business days)
                            -<b><span>&nbsp;</span><strong>$25</strong></b></li>
                    </ul>
                    <p><strong>International:</strong></p>
                    <ul>
                        <li><strong>FREE Shipping over $99 USD</strong></span></li>
                        <li><span>International Standard Shipping (8-18 Business days)
                                -&nbsp;<strong>$7.95</strong></span></li>
                        <li><span>Not Available: International Express Shipping (3-7 Business days)
                                -<strong>$30</strong></span></li>
                    </ul>
                    <p><em><strong>All packages&nbsp;are shipped with tracking!</strong></em></p>
                    <p><strong>*Marcozo&nbsp;</strong>is&nbsp;<strong>not</strong>responsible for any duties/taxes upon
                        arrival to your location &amp;&nbsp;<span>any delays due to the shipping carrier or customs
                            clearance.&nbsp;</span>Delivery time does not include Saturdays, Sundays, or Holidays.</p>
                    <p><span>*Customs, duty, and taxes are non-refundable. If you refuse a shipment because of
                            unexpected import fees, the cost of the original shipping, any brokerage/customs/duty/taxes,
                            and any return shipping charges will</span><strong>not</strong><span>be refunded.</span></p>
                    <p><span>*Free standard shipping is not available to Russia due to shipping restrictions,&nbsp;times
                            and packages being lost.&nbsp;</span></p>
                    <p>&nbsp;</p>
                    <p>250 HOMER ST.</p>
                    <p>OLEAN, NY 14760</p>
                    <p>UNITED STATES</p>
                    <p>416-836-4109</p>
                </div>
            </div>
        </div>
    </div>
</div>`
var warrantyPopup = `<div class="simple-popup simple-warranty-popup">
    <div class="popup-content">
        <div class="popup-title">Lifetime Warranty Guarantee<span class="simple-close">×</span></div>
        <div class="popup-p">
            <div class="popup-contentt">
                <div class="Rte">
                    <meta charset="utf-8">
                    <h2 style="text-align:center">Marcozo&nbsp;is committed to providing the highest standard of jewelry
                        – which is why we offer a Lifetime Warranty for all purchases of jewelry.</h2>
                    <div style="text-align:center"></div>
                    <div style="text-align:center">If your product damages, fades, or&nbsp;breaks,&nbsp;the Guarantee
                        entitles you to a&nbsp;<u>one-time</u>&nbsp;replacement of the same product -<i>all that we ask
                            is you cover the shipping &amp; handling cost of $15 for each piece.&nbsp;</i>If for any
                        reason we no longer carry the item, you are permitted to exchange your piece for another of
                        equal or lesser value.</div>
                    <div style="text-align:center"></div>
                    <div style="text-align:center">
                        <meta charset="utf-8">
                    </div>
                    <div style="text-align:center"><strong>*Lifetime Warranty does not apply to lost or stolen
                            items*</strong>&nbsp;</div>
                </div>
            </div>
        </div>
    </div>
</div>`

var ur = window.location.href;
if(ur.includes('/product') && window.innerWidth > 980){
var pppp = 0; var timerpppp = setInterval(function(){
  if( jQuery('.ProductMeta__Description').length) {
jQuery('.Product__Info .Container form').eq(0).after(jQuery('.ProductMeta__Description').eq(0));
clearInterval(timerpppp);}if( pppp > 200){clearInterval(timerpppp);}pppp++;}, 50);
}

/*
var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
  
   if(jQuery('.fh-buyNow').length == 0){
     jQuery('.ProductForm__BuyButtons').eq(0).prepend(jQuery('<div class="fh-buyNow">BUY NOW</div>'));
 }
  jQuery('.fh-buyNow').click(function(){
    jQuery('body').addClass('buying');
    jQuery('span#AddtoBag_set').click();
    jQuery('button#AddtoBag').click();
    
    var b = 0;
var timerb = setInterval(function(){
  if(jQuery('.Cart__Checkout').eq(0).length || b > 200) {
	 jQuery('.Cart__Checkout').eq(0).click();;
     clearInterval(timerb);
  }
b++;
}, 50);
  });
 
});        
  
}
*/


/*var ur = window.location.href;

if(ur.includes('/product')){

  console.log('testing');
jQuery(document).ready(function(){
console.log('heresss');
jQuery('button#AddtoBag').click(function(){
  var ur = window.location.href;
if(window.innerWidth < 768 && !jQuery('body').hasClass('buying')){
  jQuery('body').addClass('conv-redirect');
  var count = jQuery('span.Header__CartCount').html();
  var x = 0;
var cTimer = setInterval(function(){
  if(count != jQuery('span.Header__CartCount').html() || x > 200) {
	 window.location.href = '/cart';
     clearInterval(cTimer);
  }
x++;
}, 50);
}

}); 
console.log('l' + jQuery('.ProductForm__BuyButtons').length);
jQuery('.ProductForm__BuyButtons').click(function(){
  console.log('click');
  var ur = window.location.href;
if(window.innerWidth < 768){
  jQuery('body').addClass('conv-redirect');
  var count = jQuery('span.Header__CartCount').html();
  var x = 0;
var cTimer = setInterval(function(){
  if(count != jQuery('span.Header__CartCount').html() || x > 200) {
	 window.location.href = '/cart';
     clearInterval(cTimer);
  }
x++;
}, 50);
}

});   
});        
  
}*/
var ur = window.location.href;
if(ur.includes('/product')){
  
  
  jQuery(document).ready(function(){
//$('.Product__Tabs').appendTo('.ProductForm__Variants');
//$(".Product__Tabs .Collapsible:nth-child(3) button.Collapsible__Button.Heading.u-h6").text($(".Product__Tabs .Collapsible:nth-child(3) button.Collapsible__Button.Heading.u-h6").text().replace("Shipping", "Free Shipping over $99"));
    
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element);
};
var badgeTexts = [badgeText1,
                  badgeText2];
    
var popup = ["simple-shipping", "simple-warranty"]
var container = document.createElement('div');
container.className = 'marcozo-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'marcozo-img-container';
var y = document.querySelectorAll('.Product__Tabs')[0];
console.log(y);
if(document.getElementsByClassName('marcozo-img-container').length == 0){
 
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  
  
}
    
for(var i = 0; i < badgeTexts.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="marcozo-badge-container" id="'+popup[i]+'"><span class="badge'+i+'" >'+badgeTexts[i]+'</span><span class="marcozo-i">i</span></div>';
    imgContainer.appendChild(img);
    img.className = "marcozo-badges-container";
           
    
}  
});
  
  
jQuery(document).ready(function(){
 var atc = 0; var timeratc = setInterval(function(){
  if(jQuery('.simple-badges').length == 0) {
      
    jQuery('body').append(jQuery(shippingPopup))

 jQuery('body').append(jQuery(warrantyPopup))
 
  jQuery('#simple-shipping').click(function(e){
    e.preventDefault();
  e.stopPropagation();
  jQuery('.simple-shipping-popup').eq(0).addClass('open')
  });   
  
        jQuery('#simple-warranty').click(function(e){
          e.preventDefault();
  e.stopPropagation();
  jQuery('.simple-warranty-popup').eq(0).addClass('open')
  });   
 jQuery('span.simple-close').click(function(){
  jQuery(this).parent().parent().parent().removeClass('open')
}); 
    
    jQuery('.simple-popup').click(function(event){
  event.stopPropagation();
});
   jQuery(window).click(function() {
     if(jQuery('body > .open').length){
       jQuery('span.simple-close').click();
     }
  
});
clearInterval(timeratc);}if( atc > 200){clearInterval(timeratc);}atc++;}, 50);
});    
  
}
jQuery('head').append('<link rel="stylesheet" class="external-css-link" type="text/css" href="https://fonts.googleapis.com/css?family=Montserrat:200,400">');
